module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Option-5fb228b3ecbb1abd5d7511c18aabc26f9ef9f0e4a3afab207ffb8ea2eb72bd6f.svg";